import { Route } from 'react-router-dom';
import createStyles from '@guestyci/foundation/esm/createStyles/createStyles';

const useClasses = createStyles(() => ({
  root: {
    width: '2.875rem',
    height: '2.875rem',
    borderRadius: '50%',
    color: '#0F265C',
    backgroundColor: '#fff',
    border: '1px solid #0F265C',
    position: 'relative',
    marginLeft: '6.25rem',

    '&:first-child': {
      marginLeft: '0',
    },

    '&:before, &:after': {
      position: 'absolute',
      userSelect: 'none',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontWeight: 700,
    },

    '&:after': {
      content: 'attr(data-ui--step-number)',
      height: '100%',
      fontSize: '1.375rem',
      lineHeight: 1,
    },
    '&:before': {
      content: 'attr(data-ui--label)',
      top: 'calc(100% + .3rem)',
      fontSize: '0.875rem',
    },

    '&[data-ui--active="true"]': {
      backgroundColor: '#0F265C',
      '&:after': {
        color: '#fff',
      },
    },
  },
}));

const RouteStep = ({ to, step, label }) => {
  const classes = useClasses();

  return (
    <Route
      path={to}
      exact
      /* eslint-disable-next-line react/no-children-prop */
      children={({ match }) => (
        <li
          id={`step-item-${step}`}
          data-ui--step-number={step}
          data-ui--label={label}
          data-ui--active={Boolean(match)}
          className={classes.root}
        />
      )}
    />
  );
};

export default RouteStep;
